import { Locale } from "@apps/mf-overview/src/ts/i18n/LocaleContext";

/**
 * Helper that'll fetch all required data for the given locale, so that we can
 * defer loading data until it's actually needed by the application.
 */
// tslint:disable no-submodule-imports
export async function loadLocale(locale: string): Promise<Locale> {
    switch (locale) {
        case "da-dk":
            return (await import("@apps/mf-overview/src/ts/i18n/locales/da-dk")).messages;

        default:
            throw new Error(`loadLocale(): Unsupported locale "${locale}"!`);
    }
}
